<p-dialog header="Assign/Unassign Device" [(visible)]="assignWindow" [modal]="true" [responsive]="true" appendTo="body"
    width="500" height="300" [minY]="70" [maximizable]="true" [baseZIndex]="10000">
    <div *ngIf="assignAction == 'unassign'">Do you want to un-assign the device from
        <span style="font-weight: bold;">{{device.orgName}}</span> which belongs to
        <span style="font-weight: bold;">{{getAccountName(device.accountId)}}</span>.
    </div>
    <div *ngIf="assignAction == 'assign'" style="height: 450px;">
        <div ngClass="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class=" form-group">
                <label class="form-label" for="accounttoassign">Device belongs to Account
                    <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Device belongs to Account</span>
                <div class="controls">
                    <p-dropdown [options]="accounts" (onChange)="updateScreeningCenters($event)"
                        [(ngModel)]="device.accountId" placeholder="Select Account" filter="true" optionLabel="accountName"
                        [style]="{'width':'100%'}" [showClear]="true"></p-dropdown>
                    <!-- <select [(ngModel)]="device.accountId" class="form-select form-select-sm" #accounttoassign="ngModel" id="accounttoassign" name="accounttoassign">
                        <option value=null>Select Account</option>
                        <option *ngFor="let account of accounts" [ngValue]="account.id">{{account.name}}</option>
                    </select> -->
                </div>
            </div>
        </div>
        <div ngClass="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class=" form-group">
                <label class="form-label" for="centertoassign">Device belongs to Screening Center
                    <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Device belongs to Screening Center</span>
                <div class="controls">
                    <p-dropdown [options]="screeningCenters" [(ngModel)]="device.orgId"
                        placeholder="Select Screening Center" filter="true" optionLabel="orgName"
                        [style]="{'width':'100%'}" [showClear]="true"></p-dropdown>
                    <!-- <select [(ngModel)]="device.orgId" class="form-select form-select-sm" #centertoassign="ngModel" id="centertoassign" name="centertoassign">
                        <option value=null>Select Screening Center</option>
                        <option *ngFor="let center of screeningCenters" [ngValue]="center.orgId">{{account.orgName}}</option>
                    </select> -->
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button *ngIf="assignAction == 'unassign'" style="width: 92.28px;" type="button"
            class="btn btn-xs btn-success marginLR5" icon="fa fa-unlink" (click)="unAssignDevice()">Un Assign</button>
        <button *ngIf="assignAction == 'assign'" style="width: 92.28px;" type="button"
            class="btn btn-xs btn-success marginLR5" icon="fa fa-unlink" (click)="assignDevice()">Assign</button>
        <button type="button" class="btn btn-xs btn-danger marginLR5" icon="fa fa-fw fa-lg fa-times-circle"
            (click)="closeConfirmWindow()">Close</button>
    </p-footer>
</p-dialog>

<div class="card-header">
    <span [ngSwitch]="listing">
        <span *ngSwitchCase="false">Add/Update Device</span>
        <span *ngSwitchCase="true">Existing Devices</span>
    </span>
    <button class="btn btn-sm btn-warning float-right"
        style="margin-top: -4px;font-size: 14px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;"
        (click)="toggleView()">
        <span *ngIf="listing" tooltip="Click here to add new device">
            <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Device</span>
        <span *ngIf="!listing">
            <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
    </button>
</div>

<div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
        <div *ngIf="listing; then tableTemplate; else deviceFormTemplate;">
        </div>
        <ng-template #tableTemplate>
            
            <p-table 
            [value]="devices"
            [lazy]="true"
            (onLazyLoad)="onPageChange($event)"
            [paginator]="devices != null && devices.length > 0"
            [rows]="rows"
            [first]="paging.currentPage"
            [totalRecords]="totalRecords"
            
            #dt
              >
            
            
            
            <ng-template pTemplate="header">
                    <tr style="height:60px;">
                        <th style="width: 60px;text-align:center;">#
                            <!-- <p-sortIcon [field]="'deviceModel'"></p-sortIcon> -->
                        </th>
                        <th>Model
                           
                        </th>

                        <th>Category
                        </th>

                        <!-- <th [pSortableColumn]="'deviceVersion'"> Version
                            <p-sortIcon [field]="'deviceVersion'"></p-sortIcon>
                        </th> -->
                        <th style="width:120px" >Serial Number 
                        </th>

                        <th>Manufacturer
                        </th>
                        <!-- <th [pSortableColumn]="'fieldOfView'">Field Of View
                            <p-sortIcon [field]="'fieldOfView'"></p-sortIcon>
                        </th> -->
                        <th>Account
                        </th>
                        <th>Center
                        </th>
                        <th style="width: 120px;text-align:center;">Status
                        </th>
                        <th style="width:150px;text-align:center;">Action
                        </th>
                    </tr>
                    <tr 
                        style="font-family:Arial, FontAwesome;text-align: center;">
                        <td class="primeng-table-search">
                            <!-- <input class="primeng-table-search-field" disabled pInputText type="search" 
                                (input)="dt.filter($event.target.value, 'deviceModel', 'contains')"> -->
                        </td>
                        <td class="primeng-table-search">
                            <input class="primeng-table-search-field search-bar-true"
                                placeholder="&#xf002;  Device model" pInputText type="text"
                                (input)="onSearch($event.target.value,'devicemodel')">
                        </td>
                        <td class="primeng-table-search">
                            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Category"
                                pInputText type="text"
                                (input)="onSearch($event.target.value,'category')">
                        </td>
                        <!-- <td class="primeng-table-search">
                            <input class="primeng-table-search-field search-bar-true"
                                placeholder="&#xf002;  Device version" pInputText type="text"
                                (input)="dt.filter($event.target.value, 'deviceVersion', 'contains')">
                        </td> -->
                        <td class="primeng-table-search"> 
                            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Serial no." pInputText
                                type="text" (input)="onSearch($event.target.value,'serialnumber')" >
                        </td>

                        <td class="primeng-table-search">
                            <input class="primeng-table-search-field search-bar-true"
                                placeholder="&#xf002;  Manufacturer" pInputText type="text"
                                (input)="onSearch($event.target.value,'manufacturer')">
                        </td>
                        <td class="primeng-table-search" >
                            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Account Name" pInputText type="text"
                            (input)="onSearch($event.target.value,'account')">
                          </td>
                        <td class="primeng-table-search">
                            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Center"
                                pInputText type="text" (input)="onSearch($event.target.value,'center')">
                        </td>
                        <td class="primeng-table-search">
                            <!-- <input class="primeng-table-search-field" disabled pInputText type="search" 
                                (input)="dt.filter($event.target.value, 'orgName', 'contains')"> -->
                        </td>
                        <td class="primeng-table-search">
                            <!-- <input class="primeng-table-search-field" disabled pInputText type="search" 
                                (input)="dt.filter($event.target.value, 'orgName', 'contains')"> -->
                        </td>
                    </tr>
                    <tr *ngIf="devices==null || devices.length==0"
                        style="border-left: 1px solid #CCC;border-right: 1px solid #CCC;border-bottom: 1px solid #CCC;">
                        <td colspan="8">
                            <div style="padding: 5px;text-align: center;">
                                No record found
                            </div>
                        </td>
                    </tr>
                 
                </ng-template>
                <ng-template pTemplate="body" let-device let-i="rowIndex">
                    <tr class="table-striped" style="cursor: pointer;">
                        <td style="width: 60px;text-align:center;padding-bottom: 25px;padding-top:25px;">{{i + 1}}</td>
                        <td (click)="editDeviceInfo(device)">{{device?.deviceModel?.replace('_', ' ')}}</td>
                        <td (click)="editDeviceInfo(device)">{{device.deviceCategoryName}}</td>
                        <td (click)="editDeviceInfo(device)">{{device.serialNumber}}</td>
                        <td (click)="editDeviceInfo(device)">{{device.manufacturer}}</td>
                        <!-- <td (click)="editDeviceInfo(device)">{{device.fieldOfView}}</td> -->
                        <td (click)="editDeviceInfo(device)">{{device.accountName}}</td>
                        <td (click)="editDeviceInfo(device)">{{device.orgName}}</td>
                        <td class="text-center" style="width: 120px;text-align:center;">
                            <p-inputSwitch [(ngModel)]="device.status" (onChange)="updateDeviceStatus(device)">
                            </p-inputSwitch>
                        </td>
                        <td class="text-center" style="text-align:center;">
                            <button style="width: 92.28px;" (click)="viewConfirmWindow('assign',device)"
                                *ngIf="device.orgId==null" class="btn btn-xs btn-success marginLR5 assign-button">
                                <i class="fa fa-link"></i>
                                Assign</button>
                            <button style="width: 92.28px;" (click)="viewConfirmWindow('unassign',device)"
                                *ngIf="device.orgId!=null" class="btn btn-xs marginLR5 unassign-button">
                                <i class="fa fa-unlink"></i>
                                Un-Assign</button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-template>
        <ng-template #deviceFormTemplate>
            <form #deviceinfoForm="ngForm" class="mTop30" novalidate (ngSubmit)="saveDevice()">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
                    <div class=" form-group">
                        <label class="form-label" for="devicemodel">Device Name/Model
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Name of the device model/name</span>
                        <div class="controls">
                            <select [(ngModel)]="device.deviceModel" class="form-select form-select-sm" #devicemodel="ngModel"
                                name="devicemodel" id="devicemodel">
                                <option *ngFor="let device of deviceModelList" [ngValue]="device.value">{{device.name}}
                                </option>
                            </select>
                            <div [hidden]="devicemodel.valid || devicemodel.pristine" class="danger-text">
                                Device name or model is required
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
                    <div class=" form-group">
                        <label class="form-label" for="devicemodel">Device Category
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Device Category</span>
                        <div class="controls">
                            <select [(ngModel)]="device.deviceCategoryId"
                                (ngModelChange)="onDeviceCategoryChange($event)" class="form-select form-select-sm"
                                #devicecategoryid="ngModel" name="devicecategoryid" id="devicecategoryid">
                                <option *ngFor="let category of deviceCategoryList" [ngValue]="category.id">
                                    {{category.name}}</option>
                            </select>
                            <div [hidden]="devicecategoryid.valid || devicecategoryid.pristine" class="danger-text">
                                Device Category is required
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label" for="deviceversion">Device Version
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Device Version</span>
                        <div class="controls">
                            <input type="text" [(ngModel)]="device.deviceVersion" #deviceversion="ngModel"
                                pattern="^[0-9. ]*"  name="deviceversion" id="deviceversion" class="form-control"
                                placeholder="Enter device version here..." required />
                            <!-- <div [hidden]="deviceversion.valid || deviceversion.pristine" class="danger-text">
                                Device Version is required
                            </div> -->
                            <div *ngIf="deviceversion.errors && deviceversion.dirty" class="danger-text">
                                <div *ngIf="deviceversion.errors.required">
                                    Device version is required
                                </div>
                                <div *ngIf="deviceversion.errors.pattern">
                                    Invalid input, please check and enter correct details.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="clear:both;">
                    <div class=" form-group">
                        <label class="form-label" for="serialnumber">Device Serial Number
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Device Serial Number</span>
                        <div class="controls">
                            <input type="text" [(ngModel)]="device.serialNumber" #serialnumber="ngModel"
                                pattern="^[0-9A-Za-z- ]*" name="serialnumber" id="serialnumber" class="form-control"
                                placeholder="Enter device serial number here..." required />
                            <!-- <div [hidden]="serialnumber.valid || serialnumber.pristine" class="danger-text">
                                Device Serial Number is required
                            </div> -->
                            <div *ngIf="serialnumber.errors && serialnumber.dirty" class="danger-text">
                                <div *ngIf="serialnumber.errors.required">
                                    Serial Number is required
                                </div>
                                <div *ngIf="serialnumber.errors.pattern">
                                    Invalid input, please check and enter correct details.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label" for="datapath">Data Path
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Data Path</span>
                        <div class="controls">
                            <input type="text" [(ngModel)]="device.dataPath" #datapath="ngModel" name="datapath"
                                pattern=".*[a-zA-Z].*" id="datapath" class="form-control"
                                placeholder="Enter device data path here..." />
                            <!-- <div [hidden]="datapath.valid || datapath.pristine" class="danger-text">
                                Data Path is required
                            </div> -->
                            <div *ngIf="datapath.errors && datapath.dirty" class="danger-text">
                                <div *ngIf="datapath.errors.required">
                                    Datapath is required
                                </div>
                                <div *ngIf="datapath.errors.pattern">
                                    Invalid input, please check and enter correct details.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="clear:both;">
                    <div class=" form-group">
                        <label class="form-label" for="manufacturer">Manufacturer
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Manufacturer</span>
                        <div class="controls">
                            <input type="text" [(ngModel)]="device.manufacturer" #manufacturer="ngModel"
                                pattern=".*[a-zA-Z].*" class="form-control" name="manufacturer" id="manufacturer"
                                placeholder="Enter device manufacturer name here..." required />
                            <!-- <div [hidden]="manufacturer.valid || manufacturer.pristine" class="danger-text">
                                Manufacturer name is required
                            </div> -->
                            <div *ngIf="manufacturer.errors && manufacturer.dirty" class="danger-text">
                                <div *ngIf="manufacturer.errors.required">
                                    Manufacturer is required
                                </div>
                                <div *ngIf="manufacturer.errors.pattern">
                                    Invalid input, please check and enter correct details.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label" for="fieldofview">Field Of View</label>
                        <span class="desc">Field Of View</span>
                        <div class="controls">
                            <input type="text" [(ngModel)]="device.fieldOfView" #fieldofview="ngModel"
                                onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)" name="fieldofview" id="fieldofview"
                                class="form-control" placeholder="Enter device Field of View here..." />
                        </div>
                    </div>
                </div>
                <div ngClass="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="clear:both;">
                    <div class=" form-group">
                        <label class="form-label" for="associatedaccount">Device belongs to Account
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Device belongs to Account</span>
                        <div class="controls">
                            <p-dropdown [options]="accounts" name="associatedaccount"
                                (onChange)="updateScreeningCenters($event)" [(ngModel)]="device.accountId"
                                placeholder="Select Account" filter="true" optionLabel="accountName" [style]="{'width':'100%'}"
                                [showClear]="true" required></p-dropdown>
                            <!-- <select [(ngModel)]="device.accountId" class="form-select form-select-sm" #associatedaccount="ngModel" id="associatedaccount" name="associatedaccount">
                                            <option value=null>Select Account</option>
                                            <option *ngFor="let account of accounts" [ngValue]="account.id">{{account.name}}</option>
                                        </select> -->
                            <!-- <span *ngIf="isDeviceAssigned" style="font-weight: bold;padding-top: 14px;">
                                            <span>{{device.accountId.name}} - </span>
                                            <span style="color: darkgray;"> Un-Assign the device and map with new center. </span>
                                        </span> -->
                        </div>
                    </div>
                </div>
                <div ngClass="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label" for="associatedcenter">Device belongs to Screening Center</label>
                        <span class="desc">Device belongs to Screening Center</span>
                        <div class="controls">
                            <p-dropdown name="associatedcenter" [options]="screeningCenters" [(ngModel)]="device.orgId"
                                placeholder="Select Screening Center" filter="true" optionLabel="orgName"
                                [style]="{'width':'100%'}" [showClear]="true"></p-dropdown>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="col-xs-12 text-center mTop15">
                        <button [disabled]="!deviceinfoForm.form.valid" style="margin-right: 5px;" type="submit" class="btn
                                          btn-sm btn-success marginLR5">
                            <i class="fa fa-fw fa-lg fa-check-circle"></i>
                            Save Device</button>
                        <button (click)="toggleView()" style="margin-left: 5px;"
                            class="btn btn-sm btn-danger marginLR5">
                            <i class="fa fa-fw fa-lg fa-times-circle"></i>
                            Cancel</button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>